<div class="payment-required-container" *transloco="let t">
	<div class="content">
		<lucide-icon name="Lock" [size]="120" class="payment-icon"></lucide-icon>

		<h1 class="title">{{ t('paymentRequired.title') }}</h1>

		<p class="description">
			{{ t('paymentRequired.description') }}
			<br />
			{{ t('paymentRequired.contactInfo') }}
		</p>

		<div class="actions">
			<app-button
				[label]="t('paymentRequired.backToDashboard')"
				variant="secondary"
				size="large"
				(onClick)="goToDashboard()">
			</app-button>

			<app-button
				[label]="t('paymentRequired.contactSupport')"
				variant="primary"
				size="large"
				(onClick)="contactSupport()">
			</app-button>
		</div>
	</div>
</div>
